const Api = {
    '/micro-cyt/material-library/batch-save' : 1, // 手动添加视频
    '/micro-cyt/material-library/batch-tagging': 1, // 打标签
}

export default{
    Api
}